import _ from 'lodash';
import React from 'react';

import commonFunctions from '../../../../commonFunctions';

import SelectInput from '../../../common/SelectInput';

/**
 * Used to manage this component in the BootstrapTable
 */
class WarrantyAllowanceEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            warrantyAllowanceId: props.row.warrantyAllowanceId
        };

        this.updateData = this.updateData.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    focus() {
    }

    onChange(event) {
        this.setState(Object.assign({}, this.state, { warrantyAllowanceId: event.target.value }));
    }

    updateData() {
        this.props.onUpdate(this.state.warrantyAllowanceId);
    }

    render() {
        let options = [];
        if (this.props.row.coverageCaps != null) {
            const app = this.props.row.coverageCaps.filter(x => x.id === _.toNumber(this.props.row.warrantyCoverageCapId));
            if (!_.isUndefined(app) && !_.isEmpty(app)) {
                options = app[0].warrantyAllowances.map((value) => {
                    return { value: value.id, text: commonFunctions.numberToItalianEuroFormat(value.allowance) };
                });
            }
        }

        return (
            <center> <SelectInput
                name={'garanzia_' + this.state.warrantyId + '_warrantyAllowanceId'}
                label=''
                value={this.state.warrantyAllowanceId}
                defaultOptionText=''
                defaultOptionValue='-1'
                options={options}
                onChange={this.onChange} />
                <button
                    className='btn btn-info btn-xs textarea-save-btn'
                    onClick={this.updateData}>
                    Aggiorna </button>
            </center>
        );
    }
}

export default WarrantyAllowanceEditor;